/* eslint-disable max-len */
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import { Badge } from '@/common-utils/components/ui/badge';
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import RenderInternationalizedAmount from '@/common-utils/components/renders/currency/RenderInternationalizedAmount';
import DetailsButton from '@/common-utils/components/renders/detailsButton/DetailsButton';
import ColumnSelection from '@/common-utils/components/renders/dataTable/column/ColumnSelection';
import rentalFilesFields from '../../../fields/rentalFilesFields';
import RouteUrls from '@/app/root/enums/RouteUrls';
import Permissions from '@/app/permissions/Permissions';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import RenderCbLogo from '@/app/modules/terminals/components/renders/cbLogo/RenderCbLogo';

export const columnsRentalFilesId = 'rentalFiles';

export const columnsRentalFiles = (headerPackage) => {

    return ([
        // ColumnSelection
        headerPackage.selectionMode && ColumnSelection(columnsRentalFilesId),
        generateColumnDefByField({
            field: rentalFilesFields.UUID,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                return <DetailsButton
                    pathParams={{
                        remoteCollectionId: headerPackage.remoteCollectionId,
                        rentalFileId: cell.getValue(rentalFilesFields.UUID.key)
                    }}
                    urlParams={{
                        ...headerPackage.urlParams,
                        [rentalFilesFields.FILE_NUMBER.key]: cell.row.original[rentalFilesFields.FILE_NUMBER.key]
                    }}
                    baseUrl={RouteUrls.RENTAL_FILE_DETAILS.url}
                    requiredPermissions={[Permissions.PAYMENT_READ_PLBS_DETAILS.name]}
                />;
            }
        }),
        generateColumnDefByField({
            field: rentalFilesFields.FILE_NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: rentalFilesFields.POS_TERMINAL.LABEL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: rentalFilesFields.OPENING_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const openingDate = cell.getValue(rentalFilesFields.OPENING_DATE.key);
                return (
                    openingDate &&
                    <RenderDateWithFromTime value={openingDate} />
                );
            }
        }),
        generateColumnDefByField({
            field: rentalFilesFields.CLOSING_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const closingDate = cell.getValue(rentalFilesFields.CLOSING_DATE.key);
                return (
                    closingDate &&
                    <RenderDateWithFromTime value={closingDate} />
                );
            }
        }),
        generateColumnDefByField({
            field: rentalFilesFields.STATUS,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const status = rentalFilesFields.STATUS.enum[cell.getValue(rentalFilesFields.STATUS.key)];
                return <Badge
                    entity={status.entity}
                    namespace={status.namespace}
                    variant={status.variant}
                />;
            }
        }),
        generateColumnDefByField({
            field: rentalFilesFields.TOTAL_AMOUNT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const totalAmount = cell.getValue(rentalFilesFields.TOTAL_AMOUNT.key);
                const currency = getObjectAttributeFromStringKey(
                    cell.row.original,
                    generateNestedFieldAccessor(rentalFilesFields.CURRENCY)
                );
                const isNullAmount = totalAmount === 0;
                return (
                    cell &&
                    <RenderInternationalizedAmount
                        amount={totalAmount}
                        currency={currency}
                        isRemoteCollectionEmpty={isNullAmount}
                    />
                );
            }
        }),
        generateColumnDefByField({
            field: rentalFilesFields.CARD_DETAILS.TYPE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderCbLogo
                    cardType={getObjectAttributeFromStringKey(
                        cell.row.original,
                        generateNestedFieldAccessor(rentalFilesFields.CARD_DETAILS.TYPE)
                    )}
                />
            )
        }),
        generateColumnDefByField({
            field: rentalFilesFields.PAN,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <small>{cell.getValue(rentalFilesFields.PAN.key)}</small>
            )
        }),
        generateColumnDefByField({
            field: rentalFilesFields.EXPIRATION_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(rentalFilesFields.EXPIRATION_DATE.key)} noTime />
            )
        })
    ]).filter(col => !!col);
};